import { RootState } from '@next/core-lib/app';
import { EntityState } from '@ngrx/entity';

export interface FecalScoringModuleState extends RootState {
  fecalScorings?: FecalScoring[];
  selectedFecalScoring?: FecalScoring;
  selectedCountry?: string;
  isLoaded: boolean;
}

export type FecalScoringState = EntityState<FecalScoring>;

export interface FecalScoringsResponse {
  fecalScorings: FecalScoring[];
}
export interface UpsertFecalScoringResponse {
  id: number;
  isOffline?: boolean;
}
export interface FecalScoringDataSource {
  id: number;
  name: string;
  date: string;
  createdBy: string;
  numberOfPens: number;
  location: string;
  locationId: number;
  ages: string;
}

export interface FecalScoring {
  id: number;
  name: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  customerId: number;
  locationId: number;
  date: string;
  pens: Pen[];
}

export interface Pen {
  age: number;
  penScores: PenScore[];
}

export interface PenScore {
  type: FecesType;
  percentage: number;
}

export enum FecesType {
  NORMAL = 'Normal',
  SOFT = 'Soft',
  MILD = 'Mild',
  MODERATE = 'Moderate',
  SEVERE = 'Severe',
}

export interface LocationItem {
  value: number;
  name: string;
  selected: boolean;
}
